import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Alert, Grid, Row } from 'react-bootstrap';
import { NETWORK_MAX_THRESHOLD, NETWORK_PAGE } from '../../settings';
import s from './GeneLandingPage.css';
import LordOfTheSearch from '../search/LordOfTheSearch';
import NetworkContentItems from '../Content/NetworkContentItems';
import ToolHeading from '../ToolHeading';
import { setSearchTarget } from '../../actions/NetworkActions';

const GeneLandingPage = () => {
  const dispatch = useDispatch();
  const searchGeneCount = useSelector(
    state => state.currentSearch.currentSearchGenes.length,
  );

  useEffect(() => {
    dispatch(setSearchTarget(NETWORK_PAGE.pageName));
  }, []);

  const headingText = 'Functional gene networks';
  const detailText =
    'search tissue and biological process-specific gene networks';
  const url =
    'https://humanbase.readthedocs.io/en/latest/functional-networks.html';

  return (
    <div className={s.root}>
      <ToolHeading
        headingText={headingText}
        detailText={detailText}
        url={url}
      />
      <Grid fluid={false}>
        <Row>
          <div className={s.container}>
            {searchGeneCount > NETWORK_MAX_THRESHOLD && (
              <Alert bsStyle="warning" style={{ margin: 20 }}>
                Gene network searches are limited to{' '}
                {` ${NETWORK_MAX_THRESHOLD}`} genes. For your list of
                {` ${searchGeneCount}`} genes, we instead suggest applying
                functional module detection <a href="/module">here</a>.
              </Alert>
            )}
            <LordOfTheSearch singleSearchTarget />
          </div>
        </Row>
        <NetworkContentItems />
      </Grid>
    </div>
  );
};

export default withStyles(s)(GeneLandingPage);
